import KanbanBoard from "../../../../../../layout/Kanban/KanbanBoard";
import { useCallback, useState, useRef, useEffect } from "react";
import { Row, Col, Collapse } from "react-bootstrap";
import { faAdd, faFilter, faX } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { btn, btnHoverStyle } from "../../../../../../layout/Buttons/buttonStyles";
import NewModal from "../../../../documents/modals/NewModal";
import TicketView from "../../../../../../layout/Kanban/TicketView";
import ActionsFormWrapper from "../../../../crm/Actions/Form/ActionsFormWrapper";
import { useFormik } from "formik";
import ProjectActionForm from "@serie3/freelancesplaceapi/Form/Project/Project/ProjectActionForm";
import ProjectConfig from "@serie3/freelancesplaceapi/Config/Projects/ProjectConfig";
import ReferencedInputAndSubmit from "../../../../../../layout/Form/Fields/ReferencedInputAndSubmit";
import Tag from "../../../../../../layout/Buttons/Tag";
import getSettings from "@serie3/common/config/settings";
import PaymentModal from "../../../../../../layout/Payment/PaymentModal";
import crudApiLib from "@serie3/common/api/crudApi";


const Tickets = ({ tickets, setTickets, projectId, addTicket, loading }) => {
  const [showForm, setShowForm] = useState(false);
  const [editAction, setEditAction] = useState();
  const [viewTicket, setViewTicket] = useState(false);
  const [showView, setShowView] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [showSearch, setShowSearch] = useState(false);
  const [searchWords, setSearchWords] = useState([]);
  const [showPayModal, setShowPayModal] = useState(false);
  const [settings, setSettings] = useState();
  const [showDone, setShowDone] = useState(false);
  const [inactiveTickets, setInactiveTickets] = useState([]);
  const [inactiveLoading, setInactiveLoading] = useState(false);
  const inactiveLoaded = useRef(false);

  const tagRef = useRef(null);

  useEffect(() => {
    if (searchWords.length > 0) {
      handleSearch();
    } else {
      setSearchResults([]);
    }
    setSettings(getSettings());
  }, [searchWords]);

  const addElement = (refName) => {
    searchWords.push(refName.current.value);
    refName.current.value = "";
    setSearchWords([...searchWords]);
    handleSearch();
  };

  const deleteElement = (indexToDelete) => {
    const tmpSearchWords = searchWords.filter(
      (tag, index) => index !== indexToDelete
    );

    setSearchWords(tmpSearchWords);
  };

  const updateEditAction = (newEditAction) => {
    setEditAction(newEditAction);
  };

  const handleToggleDone = async (checked) => {
    setShowDone(checked);
    if (checked && !inactiveLoaded.current) {
      setInactiveLoading(true);
      const res = await crudApiLib.getAll(ProjectConfig.endpoints.actions.inactiveTickets + projectId);
      const aktionen = res.data?.aktionen || [];
      setInactiveTickets(aktionen.map((item) => item.action));
      setInactiveLoading(false);
      inactiveLoaded.current = true;
    }
  };

  const ticketForm = ProjectActionForm.createProjectActionForm(
    addTicket,
    projectId,
    setShowPayModal,
    updateEditAction
  );
  const formik = useFormik(ticketForm);

  const showTicket = useCallback((ticket) => {
    setViewTicket(ticket);
    setShowView(true);
  }, []);

  const AddEduButton = () => (
    <>
      <style>{btnHoverStyle}</style>
      <button
        className="btn-modern"
        style={{ ...btn.base, ...btn.success }}
        onClick={() => { setEditAction(null); setShowForm(true); }}
      >
        <FontAwesomeIcon icon={faAdd} /> Add
      </button>
    </>
  );

  const SearchButton = () => (
    <button
      className="btn-modern"
      style={{ ...btn.base, ...(showSearch ? btn.primary : btn.secondary) }}
      onClick={() => setShowSearch(!showSearch)}
    >
      <FontAwesomeIcon icon={showSearch ? faX : faFilter} />
    </button>
  );

  const ResetButton = () => (
    <button
      className="btn-modern"
      style={{ ...btn.base, ...btn.secondary }}
      onClick={handleResetSearch}
    >
      <FontAwesomeIcon icon={faX} />
    </button>
  );

  const handleSearch = () => {
    const lowercaseKeywords = searchWords.map((keyword) =>
      keyword.toLowerCase()
    );

    const filteredTickets = tickets.filter((obj) => {
      const title = obj.title.toLowerCase();
      const beschreibung = obj.beschreibung.toLowerCase();
      const tags = obj.tags.map((tag) => tag.name.toLowerCase()).join(" ");

      return lowercaseKeywords.some(
        (keyword) =>
          title.includes(keyword) ||
          beschreibung.includes(keyword) ||
          tags.includes(keyword)
      );
    });

    setSearchResults([...filteredTickets]);
  };

  const handleResetSearch = () => {
    setSearchWords([]);
  };

  const viewTitle = viewTicket ? viewTicket.title : "";
  const ticketList =
    searchResults.length > 0 ? [...searchResults] : [...tickets];

  return (
    <>
      {settings && <PaymentModal show={showPayModal} setShow={setShowPayModal} priceTableId={settings.pricingTables.projects}/>}
      <ActionsFormWrapper
        setShowForm={setShowForm}
        showForm={showForm}
        editAction={editAction}
        setEditAction={setEditAction}
        tickets={tickets}
        setTickets={setTickets}
        inactiveTickets={inactiveTickets}
        setInactiveTickets={setInactiveTickets}
        projectFormik={formik}
        projectId={projectId}
      />
      <NewModal show={showView} setShow={setShowView} title={viewTitle}>
        <TicketView action={viewTicket} />
      </NewModal>
      <Row>
        <Col style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <div
              onClick={() => handleToggleDone(!showDone)}
              style={{
                width: "40px", height: "22px", borderRadius: "11px", cursor: "pointer",
                background: showDone ? "#1a73e8" : "#ccc",
                position: "relative", transition: "background 0.2s",
                flexShrink: 0,
              }}
            >
              <div style={{
                position: "absolute", top: "3px",
                left: showDone ? "21px" : "3px",
                width: "16px", height: "16px", borderRadius: "50%",
                background: "#fff", transition: "left 0.2s",
              }} />
            </div>
            <span style={{ fontSize: "0.85rem", color: "#616161", fontWeight: 500 }}>Show done & canceled</span>
          </div>
        </Col>
        <Col className="text-end" style={{ display: "flex", justifyContent: "flex-end", gap: "6px" }}>
          {!showDone && <><AddEduButton /><SearchButton /></>}
        </Col>
      </Row>
      <br />

      <Collapse in={showSearch} style={{ marginLeft: "1px" }}>
        <Row>
          <Row>
            <Col>
              <ReferencedInputAndSubmit
                namedReference={tagRef}
                onClick={() => {
                  addElement(tagRef, "tags");
                }}
              />
            </Col>
          </Row>
          {searchWords.length > 0 ? (
            <Row style={{ marginTop: "8px" }}>
              <Col>
                {searchWords.map((tag, index) => {
                  return (
                    <Tag
                      key={index}
                      item={tag}
                      content={tag}
                      deleteFunction={() => {
                        deleteElement(index);
                      }}
                    />
                  );
                })}
              </Col>
              <Col md={1}>
                <ResetButton />
              </Col>
            </Row>
          ) : null}
        </Row>
      </Collapse>
      {showDone ? (
        inactiveLoading ? (
          <div style={{
            display: "flex", flexDirection: "column", alignItems: "center",
            justifyContent: "center", minHeight: "200px", gap: "12px", color: "#9e9e9e",
          }}>
            <div style={{
              width: "36px", height: "36px", borderRadius: "50%",
              border: "3px solid #e8f0fe", borderTopColor: "#1a73e8",
              animation: "spin 0.8s linear infinite",
            }} />
            <span style={{ fontSize: "0.88rem", fontWeight: 500 }}>Loading…</span>
            <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
          </div>
        ) : (
          <KanbanBoard
            actions={inactiveTickets}
            setActions={setInactiveTickets}
            setEditAction={setEditAction}
            setShowForm={setShowForm}
            setViewAction={showTicket}
            deleteUrl={ProjectConfig.endpoints.actions.delete}
            includeDone
          />
        )
      ) : loading ? (
        <div style={{
          display: "flex", flexDirection: "column", alignItems: "center",
          justifyContent: "center", minHeight: "200px", gap: "12px", color: "#9e9e9e",
        }}>
          <div style={{
            width: "36px", height: "36px", borderRadius: "50%",
            border: "3px solid #e8f0fe", borderTopColor: "#1a73e8",
            animation: "spin 0.8s linear infinite",
          }} />
          <span style={{ fontSize: "0.88rem", fontWeight: 500 }}>Loading tickets…</span>
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
      ) : (
        <KanbanBoard
          showForm={showForm}
          setShowForm={setShowForm}
          actions={ticketList}
          setActions={setTickets}
          editAction={editAction}
          setEditAction={setEditAction}
          setViewAction={showTicket}
          deleteUrl={ProjectConfig.endpoints.actions.delete}
        />
      )}
    </>
  );
};

export default Tickets;
